/**
 * NOTE:
 * - R6 April [established:新設]
 */

import { t } from "i18next"
import { AdditionType } from "../../../../../constants/enums/additioinType"
import { Field } from "../fields"
import { Version, getCurrentVersion } from "@project/shared"
import { Moment } from "moment"

/**
 * Version management: Child Disorder Type Options
 * @param {Moment} date
 * @return {Field|null}
 */
export function getProfessionalSupportSystemAddition(date: Moment) {
  const { version } = getCurrentVersion(date.format("YYYY-MM-DD"))

  switch (version) {
    case Version.BASELINE:
      return null
    default:
      return r6April
  }
}

/**
 * --------------------------------
 * @version R6_APRIL
 * --------------------------------
 */

/**
 * TODO: translate
 * @en
 * @ja 専門的支援体制加算
 */
const r6April: Field = {
  label: "専門的支援体制加算",
  name: AdditionType.PROFESSIONAL_SUPPORT_SYSTEM_ADDITION,
  fields: [
    {
      label: t("No change"),
      value: 0,
    },
    {
      label: t("No"),
      value: 1,
    },
    {
      label: t("Yes"),
      value: 2,
    },
  ],
}

/**
 * --------------------------------
 * @version BASELINE
 *
 * NONE
 * --------------------------------
 */
